import { useSelector } from "react-redux";

import { useConversionContentActions } from "store/ConversionContentSlice";

const useConversionContent = () => {
  const { setConversionContent } = useConversionContentActions();

  const { content } = useSelector((state) => state.ConversionContentSlice);

  const isInvite = content && content.type === "invites";
  const isMake = content && content.type === "makes";

  return { setConversionContent, content, isInvite, isMake };
};

export default useConversionContent;
